<template>
  <el-main>
    <!-- data1 sort btn -->
    <el-button
      v-if="!data1.sort.status && data1.data.length > 0"
      @click="data1OpenSortFunction()"
      >排序</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1SubmitSort()"
      >確定</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1CloseSortFunction()"
      >取消</el-button
    >
    <!-- data1 add btn -->
    <el-button
      v-if="!data1.sort.status"
      type="primary"
      @click="data1.addForm1.dialogVisible = true"
      >+ 照片</el-button
    >
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          <div v-if="data1.sort.status">
            <el-button
              v-if="scope.$index !== 0"
              icon="el-icon-top"
              @click="data1SortUpdateIndex(scope.$index, scope.$index - 1)"
            ></el-button>
            <el-button
              v-if="scope.$index !== data1.data.length - 1"
              icon="el-icon-bottom"
              @click="data1SortUpdateIndex(scope.$index, scope.$index + 1)"
            ></el-button>
          </div>
          <div v-if="!data1.sort.status">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="照片">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            style="width: 130px; height: 130px"
            :src="scope.row.pictureUrl"
            :preview-src-list="[scope.row.pictureUrl]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="!data1.sort.status">
            <el-button @click="data1Delete(scope.$index)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add1 dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="30%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="照片" prop="picture">
          <PictureUploader
            :fileQuantityLimit="20"
            :fileList.sync="data1.addForm1.data.picture"
            pictureSizeRemark="寬350px & 高595px"
          ></PictureUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  B_Home_Star_Add,
  B_Home_Star_GetList,
  B_Home_Star_Delete,
  B_Home_Star_Sort,
} from '@/assets/js/api';
import PictureUploader from '@/components/PictureUploader.vue';

export default {
  data() {
    return {
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            picture: [],
          },
          rules: {
            picture: [{ required: true, message: '請上傳檔案' }],
          },
        },
        sort: {
          status: false,
          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
    };
  },
  components: {
    PictureUploader,
  },
  mounted() {
    this.data1GetList();
  },
  methods: {
    // data1 get list
    data1GetList() {
      B_Home_Star_GetList()
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.data1.addForm1.loading = true;
      this.data1.addForm1.errorMessage = '';
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          const fd = new FormData();
          this.data1.addForm1.data.picture.forEach((picture) => {
            fd.append('pictures', picture.raw, picture.fileName);
          });
          B_Home_Star_Add(fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          B_Home_Star_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
    // data1 sort
    data1OpenSortFunction() {
      this.data1.sort.status = true;
      this.data1.sort.originalDataTemp = [...this.data1.data]; // 暫存原本資料
    },
    data1CloseSortFunction() {
      this.data1.sort.status = false;
      this.data1.data = [];
      this.data1.data = [...this.data1.sort.originalDataTemp]; // 回復原本資料
    },
    data1SortUpdateIndex(originalIndex, newIndex) {
      [this.data1.data[originalIndex], this.data1.data[newIndex]] = [
        this.data1.data[newIndex],
        this.data1.data[originalIndex],
      ];
      const temp = this.data1.data;
      this.data1.data = [];
      this.data1.data = temp;
    },
    data1SubmitSort() {
      const sortList = [];

      this.data1.data.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });

      B_Home_Star_Sort(sortList)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.data1.sort.status = false;
          this.data1GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },
  },
};
</script>
